import React from "react"
import Wrapper from "@components/Wrapper"
import styles from "./BannerContainer.module.scss"
import classnames from "classnames/bind"

const BannerContainer = props => {
  return (
    <section className={"container-fluid " + styles.splitBg}>
      <div className="maxWidth row">
        <Wrapper
          className="col-12 col-lg-6 bg-primary pr-lg-0 d-flex justify-content-end justify-content-xl-between flex-column align-items-center align-items-lg-start"
          placement="left"
        >
          {props.renderLeftWrapperChildren()}
        </Wrapper>
        <Wrapper
          className={classnames(
            styles.rightWrapper,
            "col-12 col-lg-6 pl-lg-0 d-flex justify-content-end flex-column",
            props.rightClassName
          )}
          placement="right"
        >
          {props.renderRightWrapperChildren()}
        </Wrapper>
      </div>
    </section>
  )
}

export default BannerContainer
